export enum Direction {
  Ascending = "ascending",
  Descending = "descending",
}
